<template>
  <b-card class="rounded-xl">
    <AddCoupon
      :isSidebarActive="openAddBannerSidebar"
      :dataType="dataType"
      :editCouponData="editCouponData"
      @closeSidebar="toggleAddBannerSidebar"
      @getAllCoupon="dataLoad"
    />
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">Coupon Management</h2>
        <!-- 
        <small class=" text-muted "
          >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
        </small> -->
      </div>
      <base-button
        outline
        type="primary"
        class="flex px-6 py-1 mx-1"
        @click="addBanner('Add')"
      >
        <feather-icon icon="PlusIcon" class="mr-1"></feather-icon> Add Coupon
        Code
      </base-button>
    </div>
    <b-input-group class="mt-12">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        placeholder="Enter Search...."
        v-model="search"
        @keyup="searchData()"
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
        >
          <feather-icon
            class="cursor-pointer mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <el-table
      class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
      header-row-class-name="thead-light table-th-color"
      :data="getCoupon.data.Record"
    >
      <el-table-column
        label="Coupon Name"
        prop="CouponName"
        min-width="150px"
        sortable
      >
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{ row.couponName }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="Coupon discount %"
        prop="coupondiscount"
        min-width="180px"
        sortable
      >
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{
            row.discountPercentage
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Coupon Code"
        min-width="140px"
        prop="couponcode"
        sortable
      >
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{ row.couponCode }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Total user limit"
        min-width="160px"
        prop="Limit"
        sortable
      >
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{ row.discountLimit }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="Start Date"
        min-width="140px"
        prop="StartDate"
        sortable
      >
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{
            new Date(row.startDate).toLocaleDateString("en-Gb", {
              year: "numeric",
              month: "long",
              day: "2-digit",
            })
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="End Date"
        min-width="140px"
        prop="EndDate"
        sortable
      >
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{
            new Date(row.expiryDate).toLocaleDateString("en-Gb", {
              year: "numeric",
              month: "long",
              day: "2-digit",
            })
          }}</span>
        </template>
      </el-table-column>

      <!-- <el-table-column
        label="Total usage"
        min-width="140px"
        prop="usage"
        sortable
      >
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{ row.discountLimit }}</span>
        </template>
      </el-table-column> -->

      <el-table-column label="Status" min-width="140px" prop="Status" sortable>
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{
            row.isActive ? "Active" : "In-active"
          }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Action" min-width="150px">
        <template v-slot="{ row }">
          <div class="flex items-center cursor-pointer">
            <feather-icon
              icon="EditIcon"
              svgClasses="w-5"
              class="mr-2"
              @click="addBanner('Edit', row)"
            ></feather-icon>
            <feather-icon
              icon="TrashIcon"
              svgClasses="w-5"
              data-toggle="tooltip"
              data-placement="top"
              @click="deleteCoupon(row)"
              title="Delete"
            ></feather-icon>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        @change="handlePageChange"
        v-model="currentPage"
        :per-page="perPage"
        :total="total_row"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import "../../scss/Index.scss";
import CategoryData from "./components/CategoryData";
import EditCategoryDetail from "./components/EditCategoryDetail";
import AddCoupon from "./components/AddCoupon";
import { mapState } from "vuex";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  CheckboxGroup,
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    EditCategoryDetail,
    AddCoupon,
  },
  data() {
    return {
      CategoryData,
      currentPage: 1,
      editModal: false,
      openAddBannerSidebar: false,
      dataType: "",
      perPage: 5,
      total_row: 1,
      currentPage: 1,
      search: "",
      editCouponData: {},
    };
  },
  methods: {
    // handleClick(item) {
    //   this.selectedItem = item;
    // },
    addBanner(type, item) {
      this.toggleAddBannerSidebar(true, type, item);
    },
    toggleAddBannerSidebar(val = false, type, item) {
      // console.log(val);
      // console.log(type);
      // console.log(item);
      this.openAddBannerSidebar = val;
      this.dataType = type;
      if (type === "Edit") {
        this.editCouponData = item;
      }
    },
    async dataLoad() {
      let payload = {
        offset: (this.currentPage - 1) * 5,
        limit: 5,
        search: this.search,
      };
      try {
        let data = await this.$store.dispatch("subscribe/GetCoupon", payload);
        this.total_row = data.data.count;
        // console.log(this.total_row);
      } catch (error) {
        console.log(error);
      }
    },
    async searchData() {
      await this.dataLoad();
    },
    handlePageChange(value) {
      this.currentPage = value;
      try {
        this.dataLoad();
      } catch (error) {}
    },
    async deleteCoupon(val) {
      // console.log(val._id);
      let payload = {
        _id: val._id,
      };
      let loader = this.$loading();
      try {
        this.$swal
          .fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#830c81",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
          })
          .then(async (result) => {
            if (result.value == true) {
              let data = await this.$store.dispatch(
                "subscribe/DeleteCoupon",
                payload
              );
              if (data.code === 200) {
                this.$swal({
                  text: "Your coupon has been successfully removed",
                  icon: "success",
                  showCancelButton: false,
                  confirmButtonColor: "#830c81",
                });
              }
              this.dataLoad();
            } else {
              this.dataLoad();
            }
          });
        loader.close();
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.dataLoad();
  },
  computed: {
    ...mapState("subscribe", {
      getCoupon: "getCoupon",
    }),
  },
};
</script>
